import { SegmentFragment } from '@occc/graphql';
import {
  Action as SegmentMembershipsAction,
  State as SegmentMembershipsState,
} from '../components/SegmentMembershipAssignment/redux/types';

const REQUEST_SEGMENT_OK = 'app/Segment/REQUEST_SEGMENT_OK';

type Types = {
  REQUEST_SEGMENT_OK: typeof REQUEST_SEGMENT_OK;
};

const types: Types = {
  REQUEST_SEGMENT_OK,
};

/* Actions */

type RequestSegmentOK = (segment: SegmentFragment) => {
  type: typeof REQUEST_SEGMENT_OK;
  segment: SegmentFragment;
};

export type Action = SegmentMembershipsAction | ReturnType<RequestSegmentOK>;

export type ActionCreators = {
  RequestSegmentOK: RequestSegmentOK;
};

export type State = {
  segment: SegmentFragment;
  segmentMemberships: SegmentMembershipsState;
};

export default types;
